import { ark } from '@ark-ui/react';
import { styled } from '@terra/ui-styled-system';
import { kbd } from '@terra/ui-styled-system';
import type { ComponentProps } from '@terra/ui-styled-system';

export type KbdProps = ComponentProps<typeof Kbd>;
export const Kbd = styled(ark.kbd, kbd);
